export default function findKey(obj: any, targetKey: string): any | undefined {
  if (obj == null || typeof obj !== 'object') return undefined

  for (const key of Object.keys(obj)) {
    if (key === targetKey) {
      return obj[key]
    }
    const value = findKey(obj[key], targetKey) // Recursive search
    if (value !== undefined) {
      return value
    }
  }
  return undefined
}
